import React from 'react';
import { withTranslation } from 'react-i18next';

import { isEasterToday } from '../../../common/isEaster';
import SvgLogoChristmasL1 from './assets/logos/christmas_l1.svg?jsx';
import SvgLogoChristmasL2 from './assets/logos/christmas_l2.svg?jsx';
import SvgLogoEasterL1 from './assets/logos/easter_l1.svg?jsx';
import SvgLogoEasterL2 from './assets/logos/easter_l2.svg?jsx';
import SvgLogoHalloweenL1 from './assets/logos/halloween_l1.svg?jsx';
import SvgLogoHalloweenL2 from './assets/logos/halloween_l2.svg?jsx';
import SvgLogoL1 from './assets/logos/logo_l1.svg?jsx';
import SvgLogoL2 from './assets/logos/logo_l2.svg?jsx';
import SvgLogoMay4thL1 from './assets/logos/may4th_l1.svg?jsx';
import SvgLogoMay4thL2 from './assets/logos/may4th_l2.svg?jsx';
import SvgSubtitleDe from './assets/subtitles/de.svg?jsx';
import SvgSubtitleEn from './assets/subtitles/en.svg?jsx';
import SvgSubtitleEs from './assets/subtitles/es.svg?jsx';
import SvgSubtitleFr from './assets/subtitles/fr.svg?jsx';
import SvgSubtitleIt from './assets/subtitles/it.svg?jsx';
import SvgSubtitlePl from './assets/subtitles/pl.svg?jsx';
import SvgSubtitlePt from './assets/subtitles/pt.svg?jsx';
import SvgBaBTitle from './assets/titles/brickabrack_l1.svg?jsx';
import SvgTitleL1 from './assets/titles/brickfilmscom_l1.svg?jsx';
import SvgTitleL2 from './assets/titles/brickfilmscom_l2.svg?jsx';

import * as style from './style.module.css'

const logos = {
  BASE: [SvgLogoL1, SvgLogoL2],
  CHRISTMAS: [SvgLogoChristmasL1, SvgLogoChristmasL2],
  HALLOWEEN: [SvgLogoHalloweenL1, SvgLogoHalloweenL2],
  MAY4TH: [SvgLogoMay4thL1, SvgLogoMay4thL2],
  EASTER: [SvgLogoEasterL1, SvgLogoEasterL2],
};

const texts = {
  de: SvgSubtitleDe,
  en: SvgSubtitleEn,
  es: SvgSubtitleEs,
  fr: SvgSubtitleFr,
  it: SvgSubtitleIt,
  pl: SvgSubtitlePl,
  pt: SvgSubtitlePt,
};

// Type: "BRICKFILMS.COM" | "BRICKABRACK"
// Theme: "BASE" | "CHRISTMAS" | "HALLOWEEN"
// Language: If null monoline, else "By Brick à Brack"
const LogoComposer = withTranslation()(({ type = "BRICKFILMS.COM", theme = "BASE", language = null, t, tReady, ...props }) => { // eslint-disable-line no-unused-vars
  const logo = logos[theme] || logos.BASE;
  let layers = [];
  let title = '';

  if (type === 'BRICKABRACK') {
    layers = [logo[0], SvgBaBTitle];
    title = t('Brick à Brack');
  } else if (type === 'BRICKFILMS.COM') {
    if (language !== null && texts[language]) {
      layers = [logo[1], SvgTitleL2, texts[language]];
      title = t('Brickfilms.com by Brick à Brack');
    } else {
      layers = [logo[0], SvgTitleL1];
      title = t('Brickfilms.com');
    }
  }

  return <div title={title} {...props} className={`${style.logo} ${props.className || ''}`}>
    {layers.map((Component, i) => <Component className={i > 0 ? style.addLayer : style.baseLayer} key={i} />)}
  </div>
});

const Logo = ({ language = null, type = null, ...props }) => {
  let theme = 'BASE';

  // Easter
  if (isEasterToday()) {
    theme = 'EASTER';
  }

   // May 4th
   if (new Date().getDate() === 4 && new Date().getMonth() === 4) {
    theme = 'MAY4TH';
  }

  // Halloween
  if ((new Date().getDate() >= 15 && new Date().getMonth() === 9) ||
    (new Date().getDate() <= 2 && new Date().getMonth() === 10)) {
    theme = 'HALLOWEEN';
  }

  // Christmas
  if (new Date().getMonth() === 11 ||
    (new Date().getDate() <= 6 && new Date().getMonth() === 0)) {
    theme = 'CHRISTMAS';
  }

  return <LogoComposer type={type || 'BRICKFILMS.COM'} theme={theme} language={language} {...props} />
};

export default React.memo(Logo);
